(function () {
    class PlugFeaturedProduct extends PlugSlider {
        constructor() {
            super();
        }

        initSlider() {
            this.elements.variantInfos = Array.from(this.querySelectorAll(".plug-feat-product__variant-info"));

            const settings = {
                a11y: true,
                centeredSlides: true,
                centerInsufficientSlides: true,
                grabCursor: true,
                navigation: {
                    enabled: true,
                    nextEl: `#${this.sliderId} .swiper-button-next`,
                    prevEl: `#${this.sliderId} .swiper-button-prev`
                },
                slidesPerView: "auto",
                on: {
                    afterInit: () => {
                        this.classList.add("is-ready");
                    },
                    slideChange: (swiper) => {
                        this.setActiveVariantInfo(swiper.activeIndex);
                    }
                }
            };

            if (this.elements.slides.length > 4) {
                settings.initialSlide = 2;
            }

            this.swiper = new Swiper(`#${this.sliderId}`, settings);
        }

        setActiveVariantInfo(index) {
            this.elements.variantInfos.forEach((info, variantIndex) => {
                if (variantIndex !== index) {
                    info.classList.add("is-hidden");
                    info.classList.remove("is-active");
                } else {
                    info.classList.remove("is-hidden");
                    window.requestAnimationFrame(() => {
                        setTimeout(() => {
                            info.classList.add("is-active");
                        }, 0);
                    });
                }
            });
        }
    }

    if (!customElements.get("plug-featured-product")) {
        customElements.define("plug-featured-product", PlugFeaturedProduct);
    }
})();